// ABOUTME: Terms of Service page component displaying legal terms and conditions
// ABOUTME: Designed to open in new tab with full scrollable content
import React from 'react';
import './TermsOfService.css';
import TOS_CONSTANTS from '../../constants/tosVersion';

const TermsOfService = () => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <header className="terms-header">
          <h1>Termos de Serviço</h1>
          <p className="terms-subtitle">Oráculo dos 12 Raios</p>
          <p className="terms-updated">
            Última atualização: {new Date(TOS_CONSTANTS.effectiveDate).toLocaleDateString('pt-BR')} (v{TOS_CONSTANTS.version})
          </p>
        </header>

        <section className="terms-section">
          <h2>1. ACEITAÇÃO DOS TERMOS E ELEGIBILIDADE</h2>
          <p>
            <strong>1.1</strong> Ao criar uma conta e usar o Oráculo dos 12 Raios, você confirma ter 18 anos ou mais
            e possuir capacidade legal para aceitar estes termos.
          </p>
          <p>
            <strong>1.2</strong> Se não concordar com qualquer parte destes termos, não use o serviço.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. AVISO IMPORTANTE - NATUREZA DO SERVIÇO</h2>
          <p>
            Este serviço é uma ferramenta de <strong>ENTRETENIMENTO</strong> e <strong>AUTOCONHECIMENTO</strong> que
            utiliza um agente de inteligência artificial baseado em Claude (Anthropic), especialmente configurado com
            a metodologia dos 12 Raios e os 9 tipos de personalidade do Eneagrama, para gerar conteúdo de autoconhecimento
            e reflexão filosófica personalizado.
          </p>

          <p><strong>ESTE SERVIÇO NÃO SUBSTITUI:</strong></p>
          <ul>
            <li>Consulta médica, psicológica ou psiquiátrica</li>
            <li>Terapia ou tratamento de saúde mental</li>
            <li>Orientação jurídica ou aconselhamento legal</li>
            <li>Consultoria financeira ou de investimentos</li>
            <li>Aconselhamento matrimonial ou familiar</li>
            <li>Orientação religiosa ou doutrina espiritual</li>
          </ul>

          <p>
            O conteúdo é gerado por algoritmos de IA sem consciência, conexão espiritual ou habilidades místicas.
            As leituras devem ser tratadas como <strong>REFLEXÕES</strong> para autoconhecimento pessoal.
          </p>

          <p><strong>RESPONSABILIDADE DO USUÁRIO:</strong></p>
          <p>
            Você é inteiramente responsável por suas interpretações e ações. <strong>NÃO</strong> tome decisões
            importantes baseadas exclusivamente nas leituras oraculares.
          </p>

          <p><strong>EMERGÊNCIAS:</strong></p>
          <p>Se você está em crise ou precisa de ajuda:</p>
          <ul>
            <li>CVV (apoio emocional): 188</li>
            <li>SAMU (emergência médica): 192</li>
            <li>Polícia: 190</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>3. USO DO SERVIÇO</h2>
          <p>
            <strong>3.1</strong> Você pode criar uma conta gratuita e receber até 3 consultas oraculares por mês.
          </p>

          <p><strong>3.2 PROTEÇÃO DA SUA PRIVACIDADE - IMPORTANTE:</strong></p>
          <p><strong>NÃO</strong> inclua informações pessoais nas suas perguntas, como:</p>
          <ul>
            <li>Nomes completos (seus ou de outros)</li>
            <li>CPF, RG ou documentos</li>
            <li>Endereços ou telefones</li>
            <li>Informações médicas específicas</li>
            <li>Dados bancários ou senhas</li>
          </ul>
          <p>
            Use apenas primeiros nomes ou iniciais se necessário. Lembre-se: suas perguntas são processadas por IA.
          </p>

          <p><strong>3.3</strong> É proibido:</p>
          <ul>
            <li>Compartilhar credenciais de acesso</li>
            <li>Usar o serviço para fins ilegais</li>
            <li>Tentar hackear ou prejudicar o sistema</li>
            <li>Fazer spam ou uso abusivo</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>4. PRIVACIDADE E PROTEÇÃO DE DADOS (LGPD)</h2>

          <p><strong>4.1 DADOS QUE COLETAMOS</strong></p>
          <ul>
            <li>Email (para autenticação)</li>
            <li>Senha (criptografada)</li>
            <li>Suas perguntas ao oráculo</li>
            <li>Suas seleções de raios e cartas</li>
            <li>Conteúdo gerado das consultas</li>
          </ul>
          <p>
            <strong>ATENÇÃO:</strong> Se você incluir informações pessoais em suas perguntas (como nomes completos,
            CPF, endereço), elas serão armazenadas como parte da sua consulta. É sua responsabilidade não incluir
            dados sensíveis.
          </p>

          <p><strong>4.2 DADOS QUE NÃO COLETAMOS ATIVAMENTE</strong></p>
          <ul>
            <li>CPF</li>
            <li>Telefone ou endereço físico</li>
            <li>Dados de pagamento</li>
            <li>Localização ou IP</li>
            <li>Cookies de rastreamento</li>
          </ul>

          <p><strong>4.3 COMPARTILHAMENTO COM IA</strong></p>
          <p>
            Apenas sua <strong>PERGUNTA</strong> e <strong>SELEÇÕES DE CARTAS</strong> são enviadas para processamento.
            Seu email e identidade <strong>NÃO</strong> são compartilhados.
          </p>

          <p><strong>4.4 SEUS DIREITOS</strong></p>
          <ul>
            <li>Acessar seus dados</li>
            <li>Corrigir informações</li>
            <li>Deletar sua conta</li>
            <li>Exportar consultas em PDF</li>
          </ul>

          <p><strong>4.5 EXCLUSÃO</strong></p>
          <ul>
            <li>Solicite nas Configurações</li>
            <li>30 dias para reativar</li>
            <li>Após: exclusão permanente</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>5. LIMITAÇÃO DE RESPONSABILIDADE</h2>
          <p>
            <strong>5.1</strong> O serviço é fornecido <strong>"COMO ESTÁ"</strong>, sem garantias.
          </p>

          <p><strong>5.2</strong> NÃO somos responsáveis por:</p>
          <ul>
            <li>Decisões baseadas no conteúdo</li>
            <li>Danos diretos ou indiretos</li>
            <li>Perdas financeiras</li>
            <li>Danos emocionais</li>
          </ul>

          <p>
            <strong>5.3</strong> Você concorda em nos isentar de reclamações resultantes do seu uso.
          </p>

          <p><strong>5.4 RESPONSABILIDADE MÁXIMA</strong></p>
          <p>
            Nossa responsabilidade limita-se ao valor pago nos últimos 12 meses.
            <br />
            Usuários gratuitos: R$ 0,00.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. MODIFICAÇÕES</h2>
          <p>
            Podemos atualizar estes termos. Mudanças significativas serão notificadas por email.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. ENCERRAMENTO</h2>
          <p>
            Podemos encerrar sua conta por violação dos termos. Você pode deletar sua conta a qualquer momento.
          </p>
        </section>

        <section className="terms-section">
          <h2>8. LEI APLICÁVEL</h2>
          <p>
            Estes termos são regidos pelas leis brasileiras.
          </p>
        </section>

        <section className="terms-section">
          <h2>9. CONTATO</h2>
          <p>
            Dúvidas: <a href="mailto:info@buenaar.app">info@buenaar.app</a>
          </p>
          <p style={{ marginTop: '20px', padding: '16px', background: '#1a1a1a', borderLeft: '4px solid #667eea', borderRadius: '4px' }}>
            Ao marcar <strong>"Li e aceito os Termos de Serviço e confirmo ter 18 anos ou mais"</strong>,
            você concorda com todos estes termos.
          </p>
        </section>

        <footer className="terms-footer">
          <p>© 2025 Buenaar - Oráculo dos 12 Raios • Todos os direitos reservados</p>
        </footer>
      </div>
    </div>
  );
};

export default TermsOfService;
